// Add type declaration for gtag
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

// Google Analytics Measurement ID
export const GA_TRACKING_ID = "G-J6C5MWEJM2"; // Replace with your GA4 Measurement ID

// Initialize Google Analytics
export const initGA = (): void => {
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]): void {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", GA_TRACKING_ID);

  // Make gtag available globally
  window.gtag = gtag;
};

// Track events with proper type definitions
interface EventParams {
  [key: string]: string | number | boolean;
}

export const trackEvent = (
  eventName: string,
  eventParams: EventParams = {}
): void => {
  if (window.gtag) {
    window.gtag("event", eventName, eventParams);
  }
};
